// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: rgb(156, 85, 34);
  background: linear-gradient(90deg, rgba(156, 85, 34, 1) 0%, rgba(32, 50, 103, 1) 42%, rgba(13, 18, 25, 1) 69%, rgba(22, 47, 60, 1) 100%);
  color: #fff;
  font-family: 'Poppins',
    sans-serif;
}

p {
  font-weight: 100;
}

a {
  text-decoration: none;
}

.app-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.kinsta-logo {
  width: 100px;
  margin: 0 0 100px;
}

.container {
  background-color: #111319;
  border-radius: 10px;
  padding: 40px;
  width: 60%;
  border: 2px solid #5c5c5c;
}

.container-title {
  text-align: center;
  width: 70%;
  margin: 0 auto 30px;
}

.container-title h1 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.container-title p {
  font-size: .9rem;
  margin-bottom: 20px;
  color: gray;
}

.services {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.services .service {
  /* background-color: red; */
  width: 100%;
  height: 150px;
  border-radius: 5px;
  border: 1px solid #5c5c5c;
  padding: 20px;
  cursor: pointer;
}

.services .service:hover {
  background-color: #1f1f1f;
}

.services .service .service-title {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #fff;
}

.services .service .service-description {
  font-size: .9rem;
  color: gray;
}

.footer {
  margin: 100px 0 0;
  text-align: center;
  width: 100%;
}

.footer p {
  font-size: .8rem;
  color: rgb(196, 196, 196);
}

.footer p a {
  color: rgb(196, 196, 196);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .kinsta-logo {
    width: 100px;
    margin: 50px 0;
  }

  .container {
    padding: 20px;
    width: 90%;
  }

  .container-title {
    width: 90%;
  }

  .services {
    flex-direction: column;
  }

  .footer {
    width: 80%;
    margin: 100px 0 20px;
  }
}

/* service section */

.search-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  gap: 10px;
}

.search-input {
  width: 70%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #5c5c5c;
  padding: 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #1f1f1f;
}

.search-input:focus {
  outline: none;
}

.btn {
  width: 30%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #5c5c5c;
  padding: 10px;
  font-size: 1rem;
  color: #fff;
  background-color: #1f1f1f;
  cursor: pointer;
  background: linear-gradient(90deg, rgba(156, 85, 34, 1) 0%, rgba(32, 50, 103, 1) 42%, rgba(13, 18, 25, 1) 69%, rgba(22, 47, 60, 1) 100%);
}

.btn:hover {
  background: #111319;
}

.details {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #5c5c5c;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.details .name-details {
  width: 50%;
}

.details .status-details {
  width: 50%;
}

.tag {
  font-size: 1rem;
  font-weight: bold;
}

.value {
  font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,wIAAwI;EACxI,WAAW;EACX;cACY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background: rgb(156, 85, 34);\n  background: linear-gradient(90deg, rgba(156, 85, 34, 1) 0%, rgba(32, 50, 103, 1) 42%, rgba(13, 18, 25, 1) 69%, rgba(22, 47, 60, 1) 100%);\n  color: #fff;\n  font-family: 'Poppins',\n    sans-serif;\n}\n\np {\n  font-weight: 100;\n}\n\na {\n  text-decoration: none;\n}\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.kinsta-logo {\n  width: 100px;\n  margin: 0 0 100px;\n}\n\n.container {\n  background-color: #111319;\n  border-radius: 10px;\n  padding: 40px;\n  width: 60%;\n  border: 2px solid #5c5c5c;\n}\n\n.container-title {\n  text-align: center;\n  width: 70%;\n  margin: 0 auto 30px;\n}\n\n.container-title h1 {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.container-title p {\n  font-size: .9rem;\n  margin-bottom: 20px;\n  color: gray;\n}\n\n.services {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.services .service {\n  /* background-color: red; */\n  width: 100%;\n  height: 150px;\n  border-radius: 5px;\n  border: 1px solid #5c5c5c;\n  padding: 20px;\n  cursor: pointer;\n}\n\n.services .service:hover {\n  background-color: #1f1f1f;\n}\n\n.services .service .service-title {\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n.services .service .service-description {\n  font-size: .9rem;\n  color: gray;\n}\n\n.footer {\n  margin: 100px 0 0;\n  text-align: center;\n  width: 100%;\n}\n\n.footer p {\n  font-size: .8rem;\n  color: rgb(196, 196, 196);\n}\n\n.footer p a {\n  color: rgb(196, 196, 196);\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .kinsta-logo {\n    width: 100px;\n    margin: 50px 0;\n  }\n\n  .container {\n    padding: 20px;\n    width: 90%;\n  }\n\n  .container-title {\n    width: 90%;\n  }\n\n  .services {\n    flex-direction: column;\n  }\n\n  .footer {\n    width: 80%;\n    margin: 100px 0 20px;\n  }\n}\n\n/* service section */\n\n.search-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n  gap: 10px;\n}\n\n.search-input {\n  width: 70%;\n  height: 40px;\n  border-radius: 5px;\n  border: 1px solid #5c5c5c;\n  padding: 20px;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #1f1f1f;\n}\n\n.search-input:focus {\n  outline: none;\n}\n\n.btn {\n  width: 30%;\n  height: 40px;\n  border-radius: 5px;\n  border: 1px solid #5c5c5c;\n  padding: 10px;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #1f1f1f;\n  cursor: pointer;\n  background: linear-gradient(90deg, rgba(156, 85, 34, 1) 0%, rgba(32, 50, 103, 1) 42%, rgba(13, 18, 25, 1) 69%, rgba(22, 47, 60, 1) 100%);\n}\n\n.btn:hover {\n  background: #111319;\n}\n\n.details {\n  width: 100%;\n  border-radius: 5px;\n  border: 1px solid #5c5c5c;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.details .name-details {\n  width: 50%;\n}\n\n.details .status-details {\n  width: 50%;\n}\n\n.tag {\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.value {\n  font-size: 1.3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
